import { type TJsonQuery } from '@/packages/JsonQuery';
import { type ReduxState } from '@/packages/redux-state/ReduxState';
import { completeJsonQueryByPinSelector, filtersSelector } from '@/packages/redux-state/store/slices/jsonQuery';
import { activePinListingIdSelector } from '@/packages/redux-state/store/slices/mapControls/selectors/dumb';

import { type IApplicationContext } from '../../types/ApplicationContext';

interface IGetSearchConditionsParams {
  applicationContext: IApplicationContext;
  reduxState: ReduxState;
}

export const getSearchConditions = ({ reduxState }: IGetSearchConditionsParams): TJsonQuery => {
  const state = reduxState.getState();

  const activePinId = activePinListingIdSelector(state);

  return activePinId ? completeJsonQueryByPinSelector(state) : filtersSelector(state);
};
